module.exports = __webpack_public_path__ + "img/img_zwsj.ade48001.png";